module.exports = __webpack_public_path__ + "img/arrow-right-solid.6a6c6c03.svg";